import { render } from "./SuperAdminLayout.vue?vue&type=template&id=7f64555e"
import script from "./SuperAdminLayout.vue?vue&type=script&lang=js"
export * from "./SuperAdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__